import { useEffect, useState } from 'react';
import { localeUI } from '../lib/format';
import { Paperclip } from 'lucide-react';
import { api } from '../lib/api';
import { useI18n } from '../lib/i18n';

type CoFile = { id: string; file_name: string | null; doc_label: string | null; ai_summary: string | null; created_at: string; url: string | null };

/** 📎 Files que subió el CONTRACTOR por JobFlow (pestaña Contractor del drawer y panel
 *  derecho del Contractor Inbox). Solo lo del partner — no mezcla files del staff. */
export function ContractorFilesCard({ claimId, compact }: { claimId: string; compact?: boolean }) {
  const { t } = useI18n();
  const [files, setFiles] = useState<CoFile[] | null>(null);

  useEffect(() => {
    let alive = true;
    api.get<{ files: CoFile[] }>(`/api/claims/${claimId}/contractor-files`)
      .then((r) => { if (alive) setFiles(r.files); })
      .catch(() => { if (alive) setFiles([]); });
    return () => { alive = false; };
  }, [claimId]);

  return (
    <div className="card" style={{ display: 'grid', gap: 8 }}>
      <b style={{ fontSize: 'var(--fs-sm)' }}><Paperclip size={14} strokeWidth={1.75} style={{ verticalAlign: 'text-bottom' }} /> {t('ci.filesFromContractor')} {files && <span className="badge gray" style={{ fontSize: 'var(--fs-2xs)' }}>{files.length}</span>}</b>
      {!files ? (
        <div className="muted" style={{ fontSize: 'var(--fs-2xs)' }}>{t('common.loadingDots')}</div>
      ) : files.length === 0 ? (
        <div className="muted" style={{ fontSize: 'var(--fs-2xs)' }}>{t('ci.noFiles')}</div>
      ) : (
        <div style={{ display: 'grid', gap: 6 }}>
          {files.map((f) => (
            <div key={f.id} style={{ display: 'flex', alignItems: 'center', gap: 8, border: '1px solid var(--line)', borderRadius: 8, padding: '7px 9px' }}>
              <span style={{ display: 'grid', gap: 1, flex: 1, minWidth: 0 }}>
                {f.url ? (
                  <a href={f.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: 'var(--fs-xs)', fontWeight: 'var(--fw-semibold)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {f.file_name || 'file'}
                  </a>
                ) : (
                  <span style={{ fontSize: 'var(--fs-xs)', fontWeight: 'var(--fw-semibold)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.file_name || 'file'}</span>
                )}
                <span className="muted" style={{ fontSize: 'var(--fs-2xs)' }}>
                  {f.doc_label ? `${f.doc_label} · ` : ''}{new Date(f.created_at).toLocaleDateString(localeUI())}
                </span>
                {!compact && f.ai_summary && (
                  <span className="muted" style={{ fontSize: 'var(--fs-2xs)', whiteSpace: 'pre-wrap' }}>{f.ai_summary}</span>
                )}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
